module.exports = __webpack_public_path__ + "static/rotor-font-adfc3da4c8c7fd244ce3ac9d69ee796b.woff2";